export enum StorageKeys {
  FAIL_REQUESTS = 'FAIL_REQUESTS',
  USER_DATA = 'USER_DATA',
  PROSPECTING_LEAD_DATA = 'PROSPECTING_LEAD_DATA',
  FORM_PERSISTER = 'FORM_PERSISTER',
  AUTH_CONTEXT = 'AUTH_CONTEXT',
  SIP = 'SIP',
}
